import measureImg from '../images/measure@2x.png';
import nameImg from '../images/name@2x.png';
import collaborationImg from '../images/collaboration@2x.png';
import {QuestionType, SurveyDataType, TextFieldKey} from './types';

export const onboardingRoot = `onboarding-root`;

export const enum SegmentedOnboardingTrackingEvents {
  SurveyStart = `[Segmented Onboarding] Started Questionnaire`,
  SurveyReturned = `[Segmented Onboarding] Returns after drop-off`,
  SelectedOption = `[Segmented Onboarding] Selected Option`,
  SubmitBtnClicked = `[Segmented Onboarding] Questionnaire Submitted`,
  NextBtnClicked = `[Segmented Onboarding] Next Button Clicked`,
  BackBtnClicked = `[Segmented Onboarding] Back Button Clicked `,
}

export const SURVEY_DATA: SurveyDataType = {
  [QuestionType.Name]: {
    type: QuestionType.Name,
    title: ({t}) => t(`signup.name.title`),
    subTitle: ({t}) => t(`signup.name.subtitle`),
    imgPath: nameImg,
    textInputs: [
      {
        key: TextFieldKey.FirstName,
        label: `signup.name.first-name`,
        placeholder: `signup.name.first-name-placeholder`,
      },
      {
        key: TextFieldKey.LastName,
        label: `signup.name.last-name`,
        placeholder: `signup.name.last-name-placeholder`,
      },
    ],
  },
  [QuestionType.Work]: {
    type: QuestionType.Work,
    title: ({t}) => t(`signup.work.title`),
    subTitle: ({t}) => t(`signup.work.subtitle`),
    options: [
      {
        value: `Product`,
        label: ({t}) => t(`signup.work.option.product`),
      },
      {
        value: `Engineering`,
        label: ({t}) => t(`signup.work.option.engineering`),
      },
      {
        value: `Marketing`,
        label: ({t}) => t(`signup.work.option.marketing`),
      },
      {
        value: `Growth`,
        label: ({t}) => t(`signup.work.option.growth`),
      },
      {
        value: `Data`,
        label: ({t}) => t(`signup.work.option.data`),
      },
      {
        value: `Design`,
        label: ({t}) => t(`signup.work.option.design`),
      },
      {
        value: `Operations`,
        label: ({t}) => t(`signup.work.option.operations`),
      },
      {
        value: `Sales`,
        label: ({t}) => t(`signup.work.option.sales`),
      },
      {
        value: `Customer Success`,
        label: ({t}) => t(`signup.work.option.customer-success`),
      },
    ],
    otherInputDetails: {placeholder: ({t}) => t(`signup.work.placeholder`)},
    imgPath: collaborationImg,
    isMultiSelect: false,
    stackBubbles: true,
    randomize: false,
  },
  [QuestionType.Role]: {
    type: QuestionType.Role,
    title: ({t}) => t(`signup.role.title`),
    subTitle: ({t}) => t(`signup.role.subtitle`),
    options: [
      {
        value: `C-Suite`,
        label: ({t}) => t(`signup.role.option.c-suite`),
      },
      {
        value: `Executive`,
        label: ({t}) => t(`signup.role.option.executive`),
      },
      {
        value: `Department Lead`,
        label: ({t}) => t(`signup.role.option.department-lead`),
      },
      {
        value: `Team Manager`,
        label: ({t}) => t(`signup.role.option.team-manager`),
      },
      {
        value: `Individual Contributor`,
        label: ({t}) => t(`signup.role.option.individual-contributor`),
      },
      {
        value: `Contractor / Freelancer`,
        label: ({t}) => t(`signup.role.option.contractor`),
      },
    ],
    imgPath: measureImg,
    stackBubbles: true,
    isMultiSelect: false,
    randomize: true,
  },
};

export const STEP_ORDER = [QuestionType.Name, QuestionType.Work, QuestionType.Role];
